import { getTvObject, tv } from '@costar-ui/cosmos';
import { filterUndefined } from '@costar-ui/utils';
import { useMemo } from 'react';
import flexOptions from '../common/flex-options/flex-options.esm.js';

var flexTV = getTvObject(flexOptions);
var flexStyles = {
  base: tv(flexTV)
};
function useFlexStyles(props) {
  var _filterUndefined = filterUndefined(props || {}),
    canShrink = _filterUndefined.canShrink,
    className = _filterUndefined.className,
    alignItems = _filterUndefined.alignItems,
    direction = _filterUndefined.direction,
    fullHeight = _filterUndefined.fullHeight,
    fullWidth = _filterUndefined.fullWidth,
    gap = _filterUndefined.gap,
    gapCol = _filterUndefined.gapCol,
    gapRow = _filterUndefined.gapRow,
    inline = _filterUndefined.inline,
    justify = _filterUndefined.justify,
    padding = _filterUndefined.padding,
    paddingX = _filterUndefined.paddingX,
    paddingY = _filterUndefined.paddingY,
    scrollable = _filterUndefined.scrollable,
    stretch = _filterUndefined.stretch;
  var classes = useMemo(function () {
    return flexStyles.base({
      canShrink: canShrink,
      className: className,
      alignItems: alignItems,
      direction: direction,
      fullHeight: fullHeight,
      fullWidth: fullWidth,
      gap: gap,
      gapCol: gapCol,
      gapRow: gapRow,
      inline: inline,
      justify: justify,
      padding: padding,
      paddingX: paddingX,
      paddingY: paddingY,
      scrollable: scrollable,
      stretch: stretch
    });
  }, [canShrink, className, alignItems, direction, fullHeight, fullWidth, gap, gapCol, gapRow, inline, justify, padding, paddingX, paddingY, scrollable, stretch]);
  return classes;
}

export { useFlexStyles as default };
//# sourceMappingURL=use-flex-styles.esm.js.map
